import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FilterField from './FilterField';
import Chip from '@material-ui/core/Chip';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  chip: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 180,
    margin:3,
  }
}));

const FilterChip = (props) => {
  const fieldConfig = props.fields.find(fc=>fc.field===props.field) || {}
  const mappedValue = fieldConfig.options?.find(f=>f.value===props.value)
  const label = `${fieldConfig.display_name || props.field} ${props.negate ? `is not ${props.operator}` : props.operator} ${mappedValue ? mappedValue.label : props.value}`;
  return(
    <Chip
      size="small"
      key={`searchFieldChip_${props.uuid}`}
      label={label}
      disabled={props.disabled}
      title={label}
      color={props.negate ? 'secondary': 'primary'}
      onDelete={()=>props.onDelete(props.uuid)}
      onClick={(event)=>props.onClick(event, props.uuid)}
      className={props.classes.chip}
    />
  )
}
// ** Proptypes ***********************
FilterChip.propTypes = {
  uuid: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  operator: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  negate: PropTypes.bool.isRequired,
  fields: PropTypes.array,
  disabled: PropTypes.bool,
  classes:PropTypes.object
};

// ** Default props *******************
FilterChip.defaultProps = {
  negate: false,
  operator: 'eq',
  fields: [],
  disabled: false,
};

const FilterEditor = (props) => {
  const [controls, setControls] = useState([])
  const [selectedControl, setSelectedControl] = useState(props.selected)
  const [filterPickerAnchorEl, setFilterPickerAnchorEl] = useState(null)
  const classes = useStyles()

  useEffect(() => {
    if(props.controls){
      setControls(Object.keys(props.controls).filter(uuid=>props.controls[uuid].field!=='created' && props.controls[uuid].field!=='type'))
    }
  },[props.controls, props.interface])

  const onClose = () => {
    setFilterPickerAnchorEl(null)
  }

  const onClick = (event, uuid) => {
    setSelectedControl(uuid)
    setFilterPickerAnchorEl(event.currentTarget)
  }

  const onAddFilter = (event) => {
    setSelectedControl(null)
    setFilterPickerAnchorEl(event.currentTarget)
  }
 
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Button variant={'outlined'} onClick={onAddFilter}>Add Filter</Button>
      <div style={{ display: 'flex', flexDirection: 'row', padding: '15px 0',flexWrap:'wrap' }}>
        {controls.filter(uuid=>props.controls[uuid]).map(uuid=><FilterChip key={uuid} disabled={props.controls[uuid].isBoolParam} classes={classes} {...props.controls[uuid]} fields={props.fields} onClick={onClick} onDelete={props.interface.remove} />)}
      </div>
      <Popover
        id="filterPickerAnchorEl"
        anchorEl={filterPickerAnchorEl}
        open={!!filterPickerAnchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <FilterField namespace={props.namespace} control={props.controls[selectedControl]} interface={props.interface} fields={props.fields} onComplete={onClose} />
      </Popover>
    </div>
  )
}

// ** Proptypes ***********************
FilterEditor.propTypes = {
  selected: PropTypes.string,
  controls: PropTypes.object.isRequired,
  interface: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  namespace: PropTypes.string.isRequired,
};

// ** Default props *******************
FilterEditor.defaultProps = {
  selected: null,
  namespace: '/bq',
};

export default FilterEditor